import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmModal from '../../common/confirm-modal/ConfirmModal';
import AntdDatePicker from '../../common/antd-form-components/AntdDatePicker';
import { confirmModalTypesValues } from '../../const-values/confirmModalTypes';
import moment from 'moment';
import { editDateClientAction } from '../../redux/clients-slice/clientsSliceThunkApi';
import { setEditEndDateModalOpened } from '../../redux/clients-slice/clientsSlice';

export default function ClientEditEndDateComponent() {
  const [EndDate, setEndDate] = useState(null);
  const dispatch = useDispatch();

  const selectedTableRow = useSelector(
    (store) => store.clients.selectedTableRow
  );
  const editEndDateModalOpened = useSelector(
    (store) => store.clients.editEndDateModalOpened
  );

  useEffect(() => {
    if (selectedTableRow?.id && selectedTableRow?.subscription?.endDate) {
      // Remove strict parsing and format to allow moment to auto-detect
      const parsedDate = moment(selectedTableRow.subscription.endDate);
      setEndDate(parsedDate.isValid() ? parsedDate.toDate() : null);
    } else {
      setEndDate(null);
    }
  }, [selectedTableRow]);

  const handleEditDateClient = () => {
    if (selectedTableRow?.id && EndDate) {
      const formData = new FormData();
      formData.append('user_id', selectedTableRow.id);
      formData.append(
        'endDate',
        moment(EndDate).locale('en').format('YYYY-MM-DD')
      );

      dispatch(
        editDateClientAction({
          dataToBeSubmitted: formData,
          isClientPage: true
        })
      );
    } else {
      console.log('❌ يرجى اختيار تاريخ انتهاء صالح');
    }
  };

  return (
    <ConfirmModal
      modalTitle="تعديل تاريخ الانتهاء"
      modalOpened={editEndDateModalOpened}
      modalType={confirmModalTypesValues?.successModal}
      setModalOpened={(v) => dispatch(setEditEndDateModalOpened(v))}
      handleAccept={handleEditDateClient}
    >
      <div className="container-date">
        <h2>رقم العميل: {selectedTableRow?.phone}</h2>
        <AntdDatePicker
          OldDate={
            selectedTableRow?.id && selectedTableRow?.subscription?.endDate
          }
          fieldName="endDate"
          dateState={EndDate}
          setDateState={setEndDate}
          setValue={() => {}}
          errors={{}}
          setError={() => {}}
          clearErrors={() => {}}
          errMsg="❌ يرجى تحديد تاريخ صحيح"
          // selectedObject={{ ["endDate"]: EndDate }} // Ensure key matches
          // selectedDateKeyName="endDate"
        />
      </div>
    </ConfirmModal>
  );
}
